export var handleBackToTop = function () {
    var skipLink = document.querySelector('[data-gui="skip-to-content-gui"]');
    // sets tab focus to skip link at top of page
    if (skipLink)
        skipLink.focus();
    return window.scroll({
        top: 0,
        left: 0,
        behavior: 'smooth',
    });
};
